<template>
  <div id="forgot-password-box">

    <div class="content">
      <div id="forgot-password-content">
        <ul class="reset-type list-unstyled">
          <li @click="isShowResetPhonePwd=false">
            <a href="javascript:void(0)" :class="{'active': !isShowResetPhonePwd}">{{ $t('email') }}</a>
          </li>
          <li @click="isShowResetPhonePwd=true">
            <a href="javascript:void(0)" :class="{'active': isShowResetPhonePwd}">{{ $t('phone') }}</a>
          </li>
        </ul>

        <forgot-email-pwd class="email-phone-reset" v-show="!isShowResetPhonePwd"></forgot-email-pwd>
        <reset-phone-pwd class="email-phone-reset" v-show="isShowResetPhonePwd"></reset-phone-pwd>
      </div>
    </div>

  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/formstyle";


  #forgot-password-box {
    width: 100%;
    background: url('/static/img/loginRegister/bg.png') no-repeat center bottom;
    min-height: 100vh;
    padding-top: 1.6rem;
  }

  #forgot-password-content {
    max-width: 4rem;
    width: 100%;
    margin: 0 auto;
  }

  .reset-type {
    clear: both;
    text-align: center;
    li {
      display: inline-block;
      a {
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        color: #999;
        display: inline-block;
        padding-bottom: 12px;
      }
      .active {
        color: #333;
        background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / 40px 4px no-repeat;
      }
      &:first-child {
        margin-right: .62rem;
      }
      &:last-child {
        margin-left: .62rem;
      }
    }
  }

  .email-phone-reset {
    margin-top: .4rem;
  }

  @media (max-width: 991px) {
    #forgot-password-box {
      padding-top: 0.9rem;
    }
  }

  @media (max-width: 767px) {
    #forgot-password-box {
      padding: .24rem .24rem 0;
      background-image: url('/static/img/loginRegister/bg_h5.png');
      background-size: 100%;
    }
    .reset-type li {
      &:first-child {
        margin-right: .2rem;
      }
      &:last-child {
        margin-left: .2rem;
      }
    }
  }
</style>

<script>
  import ForgotEmailPwd from '../forgotEmailPwd/ForgotEmailPwd.vue'
  import ResetPhonePwd from '../../../components/resetPhonePwd/index.vue'
  import locales from './lang'

  export default {
    name: 'forgot-pwd-view',
    components: {
      ForgotEmailPwd,
      ResetPhonePwd
    },
    data: function () {
      return {
        isShowResetPhonePwd: false
      }
    },
    locales,
    created: function () {
      if (window.localStorage.getItem('token') !== null) {
        this.$router.replace('/dashboard')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ForgotPwd.vue?5177f868